import { isDmrReactUrlEnabled, isDmrReactUrlTouchEnabled } from 'reactApp/appHelpers/featuresHelpers';

export const getABReactPaymentLink = (url: string, isMobile = false) => {
    const isNewUrlEnabled = (isMobile && isDmrReactUrlTouchEnabled) || (!isMobile && isDmrReactUrlEnabled);

    if (!isNewUrlEnabled) {
        return url;
    }

    return url?.replace(/\/\/pw\.money\.mail\.ru\/pw\/[\d-]+\//, '//checkout.vkpay.io/');
};
